import { useEffect, useState } from "react";
import { api } from "./api";

const KEY = "tr_ux_mode";
const EVT = "tr-ux-mode";

export const getUxMode = () => localStorage.getItem(KEY) || "pro";

export const setUxMode = async (mode) => {
  localStorage.setItem(KEY, mode);
  window.dispatchEvent(new CustomEvent(EVT, { detail: mode }));
  try { await api.put("/ux/prefs", { ux_mode: mode }); } catch { /* no-op */ }
};

// Pull the server-side preference once (Layout mount) and reconcile localStorage.
export const syncUxMode = async () => {
  try {
    const { data } = await api.get("/ux/prefs");
    if (data?.ux_mode && data.ux_mode !== getUxMode()) {
      localStorage.setItem(KEY, data.ux_mode);
      window.dispatchEvent(new CustomEvent(EVT, { detail: data.ux_mode }));
    }
    return data;
  } catch { return null; }
};

export const useUxMode = () => {
  const [mode, setMode] = useState(getUxMode);
  useEffect(() => {
    const h = (e) => setMode(e.detail);
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return mode;
};

// Renders the Simple or Pro experience for shared routes (/dashboard, /operations).
export const ModeSwitch = ({ simple, pro }) => {
  const mode = useUxMode();
  return mode === "simple" ? simple : pro;
};
